export const DEFAULT_LOCALE = "en";
export const INFO_PORTUGUESE_MODAL_LOCAL_STORAGE_KEY = "infoPortugueseModalViewed";

// context(alexandrchebotar, 2024-12-05): local language names are used
export const localeOptions = [
  { value: "en", label: "English" },
  { value: "pt", label: "Português" },
];
